import { CoreLevel } from '@wix/da-react-context/pkg/publicSession';
import { formatDollars } from './formatting';
import { dollarsToPoints } from './points';

export const DOLLAR_PRICE_MIN_VALUE = 1;
export const MIN_PRICE_TO_ACCEPT_DOLLARS = 1;

export const POINTS_MIN_VALUE = 1;
export const POINTS_MAX_VALUE = 8000;

export const MAX_PRICE_NON_CORE = 100;
export const MAX_CORE_AND_CORE_PLUS = 1000;
export const MAX_CORE_PRO_AND_CORE_PRO_PLUS = 10000;
export const MAX_CORE_MAX = 15000;

export const getPointsPriceValidationError = (
  value: number,
  maxValue: number,
  t
): string | undefined => {
  if (!value) {
    return t('common.pointsInput.validation.error.required');
  } else if (value < POINTS_MIN_VALUE) {
    return t('common.pointsInput.validation.error.minValue', {
      min: POINTS_MIN_VALUE,
    });
  } else if (value > maxValue) {
    return t('common.pointsInput.validation.error.maxValue', {
      max: maxValue,
    });
  }
  return undefined;
};

export const getDollarPriceValidationError = (
  value: string,
  maxValue: number,
  t
): string | undefined => {
  if (value === '') {
    return t('common.dollarPriceInput.validation.error.missingValue');
  } else if (isNaN(+value)) {
    return t('common.dollarPriceInput.validation.error.invalidValue');
  } else {
    if (+value < DOLLAR_PRICE_MIN_VALUE) {
      return t('common.dollarPriceInput.validation.error.minValue', {
        min: formatDollars(DOLLAR_PRICE_MIN_VALUE),
      });
    } else if (+value > maxValue) {
      return t('common.dollarPriceInput.validation.error.maxValue', {
        max: formatDollars(maxValue),
      });
    }
  }
};

export const getMaxPriceForCoreLevel = (coreLevel: CoreLevel) => {
  switch (coreLevel) {
    case 'core_access':
    case 'core_plus':
      return MAX_CORE_AND_CORE_PLUS;
    case 'core_pro':
    case 'core_pro_plus':
      return MAX_CORE_PRO_AND_CORE_PRO_PLUS;
    case 'core_max':
      return MAX_CORE_MAX;
    default:
      return MAX_PRICE_NON_CORE;
  }
};

export const getMaxPriceInPointsForCoreLevel = (coreLevel: CoreLevel) =>
  dollarsToPoints(getMaxPriceForCoreLevel(coreLevel));
